import React from 'react';
import queryString from 'query-string';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import MessagePopup from './MessagePopup.jsx';
import SessionTimeOutMessagePopup from './SessisonTimeOutPopup.jsx';

class PageMessage extends React.Component {
    constructor(props) {
        super(props);
        this.displayMessage = this.displayMessage.bind(this);
    }

    displayMessage() {
        let displayType = null;
        let messageType = null;
        let messageCode = null;
        let message = null;
        try {
            displayType = this.props.message.displayType;
        } catch(e){}
        try {
            messageType = this.props.message.messageType;
        } catch(e){}
        try {
            messageCode = this.props.message.messageInfo.messageCode;
        } catch(e){}
        try {
            message = this.props.message.messageInfo.message;
        } catch (e) { }

        let messageContent = null;
        if (messageCode === 'SERVICE_ERROR') {
            messageContent = (<div className="alert alert-danger">
               {message}
            </div>)
        } else if (messageCode === 'LOGIN_FAILED') {
            messageContent = (<div className="alert alert-danger">
                The System could not Log you on.<br />
                Make sure your User name is correct then type your password again.<br />
                Letters in password must be typed using the correct case.<br />
                Make sure that Caps Lock is not accidentally on.<br />
                <span className="small">
                    [If the problem still persist contact your System Administrator.]<br />
                </span>
            </div>)
        } else {
            if (messageType === 'info') {
                messageContent = (<div className="alert alert-info">{message}</div>)
            } else if (messageType == 'success') {
                messageContent = (<div className="alert alert-success">{message}</div>)
            } else if (messageType == 'warning') {
                messageContent = (<div className="alert alert-warning">{message}</div>)
            } else if (messageType == 'error') {
                messageContent = (<div className="alert alert-danger">{message}</div>)
            }
        }

        if (displayType === 'popup') {
            let popuptitle = null;
            let popupAction = null;
            let popupActionHandler = null;
            try {
                popuptitle = this.props.message.messageInfo.popuptitle;
            } catch (e) { }
            try {
                popupAction = this.props.message.popupAction;
            } catch (e) { }
            try {
                popupActionHandler = this.props.message.popupActionHandler;
            } catch (e) { }
            return (<MessagePopup displayType={displayType} messageContent={messageContent}  popupTitle={ (typeof popuptitle !=='undefined' && popuptitle !=='' && popuptitle != null) ? popuptitle:'Message'}
                popupAction={popupAction}
                popupActionHandler={popupActionHandler}

                />)
        } 

		if (displayType === 'timeoutpopup') {
            let popuptitle = null;
            let popupAction = null;
            let popupActionHandler = null;
            displayType = null;
            try {
                popuptitle = this.props.message.messageInfo.popuptitle;
            } catch (e) { }
            try {
                popupAction = this.props.message.popupAction;
            } catch (e) { }
            try {
                popupActionHandler = this.props.message.popupActionHandler;
            } catch (e) { }
            return (<SessionTimeOutMessagePopup messageContent={messageContent} closePopup={this.props.closePopup} redirectToLogin={this.props.redirectToLogin}  popupTitle={ (typeof popuptitle !=='undefined' && popuptitle !=='' && popuptitle != null) ? popuptitle:'Message'}
                popupAction={popupAction}
                popupActionHandler={popupActionHandler}

                />)
        }

        else {
			return messageContent
        }
    }


    render() {
        return this.displayMessage();
    }
}
const MessageAPI = {
	convertToError(err,displayType,messageType,messageCode,message) {
        let status = err.response.status;
        let finalMessage = message===''? 'Internal Error':message;
        let finalMessageCode = messageCode===''? 'SERVER_ERROR':messageCode;
        let finalMessageType = messageType===''? 'error':messageType;
        let finalDisplayType = (typeof displayType  === 'undefined' || displayType==='')? 'inline':displayType;
        if(status != null && status != '' && status != 200 && err.response.data.message === undefined) {
            try{
                let errorList = err.response.data.errorList;
                let fieldErrorList = [];
                for (var i = 0; i < errorList.length; i++) {
                    let error = errorList[i];
                    let errorMessage = error.message;
                    fieldErrorList.push(<div>{errorMessage}</div>);
                }
                finalMessage =   (typeof finalMessage  !== 'undefined' && finalMessage!=='')?finalMessage:fieldErrorList;
                finalMessageCode = "SERVICE_ERROR";
                finalMessageType = "";
            } catch(e){}
            
        } else {
            try{
                finalMessage =   (typeof finalMessage  !== 'undefined' && finalMessage!=='')?finalMessage:err.response.data.message;
            } catch(e){}
            try{
                finalMessageCode =  (typeof finalMessageCode  !== 'undefined' && finalMessageCode!=='')?finalMessageCode:err.response.data.messageCode;
            } catch(e){}
            try{
                finalMessageType = (typeof finalMessageType  !== 'undefined' && finalMessageType!=='')?finalMessageType:err.response.data.messageType;
            } catch(e){}	
        }
        
       	
		let errObj = {appMessage: { displayType: finalDisplayType, messageType: finalMessageType, messageInfo: { message: finalMessage, messageCode: finalMessageCode} } }
		return errObj;
    },
    validateField(fieldValue, fieldName, minLength, regex){
        try{
            if(fieldValue == null || typeof fieldValue === 'undefined' || fieldValue === '' || fieldValue.trim().length === 0 ){
                //throw an exception
                throw fieldName+" is a mandatory field";
            }
            if(typeof minLength  !== 'undefined'){
                if(minLength > fieldValue.trim().length){
                    //throw an exception
                    throw fieldName+" should have at least "+minLength+" characters.";
                }
            }
            if(typeof regex !== 'undefined'){
                if(!fieldValue.match(regex)){
                    throw fieldName+" contains invalid characters.";
                }
            }
        } catch(error){
            throw { displayType: 'inline', messageType: 'error', messageInfo: { message: error, messageCode: 'FIELD_VALIDATION_ERROR' } };
        }
    },
    convertJSErrorToError(error){
        return { displayType: 'inline', messageType: 'error', messageInfo: { message: error, messageCode: 'FIELD_VALIDATION_ERROR' } };
    }
};
export { PageMessage as default, PageMessage, MessageAPI};
